<div *ngIf="!busy && !connected">
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Client Code:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="clientCode" />
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'general.username' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="username" />
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'general.password' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="password" id="Password" />
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
    </div>
    <div class="col-md-8" style="text-align: right;">
      <button type="button" (click)="SaveSettings()" class="iso-round-button secondary"
              [disabled]="password === null || username === null || username.length === 0 || password.length === 0 || clientCode === null || clientCode.length === 0">
        {{ 'messaging.connect' | translate }}
      </button>
    </div>
  </div>

</div>

<div *ngIf="connected" class="margin-top-16">
  <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
  <app-shopify-defaults [partner]="partner"></app-shopify-defaults>
  <!--  todo (dcorbett) - removed (status)="configurationUpdate($event)"-->
</div>

